import { useState } from "react";
import { AddressDetails } from "../../../../core/api/addresses/types";
import useUser from "../../../../core/user/useUser";
import { addAddress } from "../../../../core/api/addresses/addresses";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import AddressForm from "./AddressForm";
import useTranslations from "../../../../core/i18n/useTranslations";
import { notifyApiErrors } from "../../../../core/helpers/helpers";
import Button from "../../../../ui-lib/components/Button/Button";

const AddAddressModal = ({
  objectId,
  onAdd,
}: {
  objectId: string;
  onAdd: () => void;
}) => {
  const t = useTranslations();

  const { authenticatedRequest } = useUser();

  const [addAddressModalOpen, setAddAddressModalOpen] = useState(false);

  const onSubmit = async (addressDetails: AddressDetails) => {
    try {
      addressDetails = {
        ...addressDetails,
        latitude: addressDetails.latitude!
          ? +addressDetails.latitude
          : undefined,
        longitude: addressDetails.longitude!
          ? +addressDetails.longitude
          : undefined,
      };
      await addAddress(objectId, addressDetails, authenticatedRequest);
      notify({
        message: t("Messages:add_address_success"),
      });
      onAdd();
      setAddAddressModalOpen(false);
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    }
  };

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        image="map"
        text={t("Objects:address_add")}
        onClick={() => setAddAddressModalOpen(true)}
      />
      {addAddressModalOpen && (
        <AddressForm
          isOpen={addAddressModalOpen}
          labels={{
            title: t("Objects:address_add"),
            description: t("Objects:address_add_description"),
            submit: t("Objects:address_add"),
          }}
          onSubmit={onSubmit}
          onClose={() => setAddAddressModalOpen(false)}
        />
      )}
    </>
  );
};

export default AddAddressModal;
